import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CustomHeading from './CustomHeading';
import CustomLabel from './CustomLabel';

// The reusable TableComponent that accepts `data` and `columns` as props
const TableComponent = ({ heading, label, data, columns, bodyTemplate }) => {
    return (
        <>
            {heading && <CustomHeading title={heading} />}
            {label && <CustomLabel title={label} extraClassName={"mt-4"} />}
            <DataTable className='karla' value={data} tableStyle={{ minWidth: '100%' }}>
                {columns.map((col, index) => (
                    <Column className='karla' body={col.bodyTemplate} key={index} field={col.field} header={col.header} style={{ fontSize: '16px', fontWeight: '600px', color: '#393839' }} />
                ))}
            </DataTable>
        </>
    );
};

export default TableComponent;




